import { gql, useMutation } from '@apollo/client'

export const UNFOLLOW_TAG = gql`
  mutation ($tag_id: String!) {
    unfollowTag(tag_id: $tag_id) {
      id
    }
  }
`

export const useUnfollowTag = () => {
  const [mutate, { data, error, loading }] = useMutation(UNFOLLOW_TAG, {
    update(cache) {
      cache.modify({
        fields: {
          getUserTagFollows() {}
        }
      })
    }
  })
  return { mutate, data, error, loading }
}
